(function () {
  var EVENT_ENDPOINT = "/apps/portal/pull-list-event";

  function sessionKey() {
    try {
      var key = "darkstone_pull_session";
      var existing = window.sessionStorage.getItem(key);
      if (existing) return existing;
      var created = window.crypto && window.crypto.randomUUID
        ? window.crypto.randomUUID()
        : "session-" + Date.now() + "-" + Math.random().toString(36).slice(2);
      window.sessionStorage.setItem(key, created);
      return created;
    } catch (_error) {
      return "session-unavailable";
    }
  }

  function track(eventType, source, metadata) {
    var body = new URLSearchParams();
    body.set("eventType", eventType);
    body.set("source", source || "storefront");
    body.set("sessionKey", sessionKey());
    body.set("metadata", JSON.stringify(metadata || {}));
    fetch(EVENT_ENDPOINT, {
      method: "POST",
      credentials: "same-origin",
      keepalive: true,
      headers: { "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8" },
      body: body.toString(),
    }).catch(function () {});
  }

  function returnToLogin() {
    var configured = window.routes && typeof window.routes.storefront_login_url === "string"
      ? window.routes.storefront_login_url.split("?")[0]
      : "";
    if (!configured) return "/pages/pull-list";
    return configured + "?return_to=" + encodeURIComponent(window.location.pathname + window.location.search);
  }

  function hasStorefrontCustomer() {
    return Boolean(
      window.customer_id
      || window.customerId
      || (window.Shopify && window.Shopify.customer_id)
    );
  }

  function isLoginRedirect(response) {
    if (!response.redirected) return false;
    try {
      var url = new URL(response.url, window.location.origin);
      return url.pathname.indexOf("/customer_authentication/") === 0
        || url.pathname.indexOf("/account") === 0
        || /(^|\.)shopify\.com$/i.test(url.hostname);
    } catch (_error) {
      return false;
    }
  }

  async function submitFollow(form) {
    var button = form.querySelector('button[type="submit"]');
    var status = form.querySelector("[data-follow-status]");
    var original = button ? button.textContent : "Follow series";
    var source = form.getAttribute("data-source") || "storefront";
    var title = form.getAttribute("data-product-title") || "";
    if (button) {
      button.disabled = true;
      button.setAttribute("aria-busy", "true");
      button.textContent = "Following…";
    }
    if (status) status.textContent = "";
    track("pull_list_cta_click", source, { placement: source });
    if (!hasStorefrontCustomer()) {
      window.location.href = returnToLogin();
      return;
    }

    try {
      var body = new URLSearchParams(new FormData(form));
      var response = await fetch(form.action, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
        body: body.toString(),
      });

      if (isLoginRedirect(response)) {
        window.location.href = returnToLogin();
        return;
      }
      if (!response.ok) {
        var message = await response.text().catch(function () { return ""; });
        throw new Error(message || "Open the pull list to follow this series.");
      }

      if (button) {
        button.textContent = "Series followed ✓";
        button.removeAttribute("aria-busy");
      }
      if (status) status.textContent = "Future cataloged issues for this series will be added to your pull list.";
      track("pull_series_subscribed", source, { placement: source });
    } catch (error) {
      if (button) {
        button.disabled = false;
        button.removeAttribute("aria-busy");
        button.textContent = original;
      }
      if (status) {
        status.innerHTML = "Could not follow directly. <a href=\"/pages/pull-list?q=" + encodeURIComponent(title) + "\">Find it in the pull list</a>.";
      }
    }
  }

  document.addEventListener("submit", function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches("[data-darkstone-follow-series]")) return;
    event.preventDefault();
    if (form.getAttribute("data-busy") === "1") return;
    form.setAttribute("data-busy", "1");
    submitFollow(form).finally(function () { form.removeAttribute("data-busy"); });
  });

  document.addEventListener("click", function (event) {
    var link = event.target instanceof Element ? event.target.closest("[data-darkstone-pull-cta]") : null;
    if (!link) return;
    track("pull_list_cta_click", link.getAttribute("data-source") || "storefront-link", {
      placement: link.getAttribute("data-source") || "storefront-link",
    });
  });
})();
